var breakpoints = {
  mobile: 600
};

export default breakpoints;
